<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><span aria-label="page 30" id="page_30" role="doc-pagebreak"><img alt="Image" class="imagefp" src="e9781481403887/images/f0030-01.jpg"/></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03_sub01.vue?b96bea1e